/*
 * File: OverlappedAppointmentsDialog.js
 * Project: mp-mobile-app
 *
 * Created by vamsi
 *
 * Copyright (c) 2019 MacPractice, Inc. All rights reserved.
 *
 * Description: Shows and styles an alert dialog when appointment can't be scheduled due to an overlapping appointment based on the Scheduling preference in the native app
 */
import React from "react";
import { observer } from "mobx-react";
import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";
import DialogActions from "@material-ui/core/DialogActions";
import Button from "@material-ui/core/Button";
import { Typography, withStyles } from "@material-ui/core";
import PropTypes from "prop-types";
import DateFormatter from "utils/DateFormatter";

const styles = theme => ({
  overlappingHeader: {
    fontWeight: 500,
    color: theme.palette.common.black
  }
});

class OverlappedAppointmentsDialog extends React.Component {
  handleClose = async () => {
    let error = Object.assign({}, this.props.appt.error);

    if (
      error.transparencies === undefined ||
      error.transparencies.length === 0
    ) {
      await this.props.appt.delete();
      delete error["confirmAppointmentId"];
    }
    delete error["appointments"];
    this.props.appt.setError(error);
  };

  render() {
    let error = this.props.appt.error || {};
    let hasApptErrors =
      Array.isArray(error.appointments) && error.appointments.length > 0;
    const { classes } = this.props;
    return (
      <Dialog open={hasApptErrors} onClose={this.handleClose}>
        {hasApptErrors &&
          <React.Fragment>
            <DialogTitle id="scroll-dialog-title" disableTypography>
              <Typography variant="h6" className={classes.overlappingHeader}>
                Overlapping Appointments!
              </Typography>
            </DialogTitle>
            <DialogContent>
              {error.appointments && (
                <React.Fragment>
                  <Typography variant="body1">
                    This appointment is overlapping another appointment already
                    scheduled at this time. Please select a different time or go to
                    Scheduling &gt; Preferences and select the &quot;Allow
                    Appointment Overlaps&quot; on the Desktop application.
              </Typography>
                  <br />
                  {error.appointments.length > 0 && (
                    <Typography variant="h6" className={classes.overlappingHeader}>
                      Blocking
                      {error.appointments.length > 1
                        ? " Appointments"
                        : " Appointment"}
                    </Typography>
                  )}
                  {error.appointments.map((appt, idx) => {
                    const apptDate = DateFormatter.mdy(appt.start);
                    const apptTimeStart = DateFormatter.time(appt.start);
                    const apptTimeEnd = DateFormatter.time(appt.end)
                    return (
                      <React.Fragment key={idx}>
                        <b>Date: </b>
                        {apptDate}
                        <br />
                        <b>Time: </b>
                        {apptTimeStart + " - " + apptTimeEnd}
                        <br />
                        <br />
                      </React.Fragment>
                    );
                  })}
                </React.Fragment>
              )}
            </DialogContent>
            <DialogActions>
              <Button onClick={this.handleClose} color="primary">
                Ok
              </Button>
            </DialogActions>
          </React.Fragment>
        }
      </Dialog>
    );
  }
}

OverlappedAppointmentsDialog.propTypes = {
  appt: PropTypes.object.isRequired,
  classes: PropTypes.object.isRequired
};

export default withStyles(styles)(observer(OverlappedAppointmentsDialog));
